module.exports = __webpack_public_path__ + "static/hero-illustration-67c7eff4f41d72480fa3e76e3389a7d2.svg";